import { useFollowableStories } from './useFollowableStories';
import { useFollowableTags } from './useFollowableTags';
import { useIsFollowAllowed } from './useIsFollowAllowed';

export const useIsMyTopicsAllowed = () => {
  const isFollowAllowed = useIsFollowAllowed();

  const { followableStories } = useFollowableStories();

  const { followableTags } = useFollowableTags();

  return isFollowAllowed && (followableStories.length > 0 || followableTags.length > 0);
};
